import { track, trackAutoEvent } from '../../vendor/splitmetrics-track/index';



export const EVENT_NAME = 'main_gallery_slide_view';


export default (params, isAutoEvent = false) => {
  if (isAutoEvent) {
    trackAutoEvent(EVENT_NAME, params, {});
  } else {
    track(EVENT_NAME, params, {});
  }
};



// WEBPACK FOOTER //
// ./src/lib/track-event/main-gallery-slide-view.js